import React from "react"
import "./Checkbox.scss"

let lastId = 0

function Checkbox({ item, checked, onAdd, onDelete, ...rest }) {
  function handleChange(event) {
    if (event.target.checked) {
      onAdd(item.key)
    } else {
      onDelete(item.key)
    }
  }
  lastId++
  const attrChecked = checked ? "checked" : ""
  return (
    <div className="sport-object-checkbox">
      <input
        id={"checkbox" + lastId}
        checked={attrChecked}
        type="checkbox"
        onChange={handleChange}
        {...rest}
      />
      <label htmlFor={"checkbox" + lastId}>{item.value}</label>
    </div>
  )
}

export default Checkbox
